import { Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { revaluationMissingMessage } from './revaluationMessages'

export function RevaluationMissingBadge({ consolidated = false }: { consolidated?: boolean }) {
  return (
    <Tooltip title={revaluationMissingMessage(consolidated)}>
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border bg-amber-50 text-amber-700 border-amber-200">
        <InfoCircleOutlined />
        Revaluation data missing
      </span>
    </Tooltip>
  )
}
